import React, { useEffect, useState, useContext } from "react";

import '../../css/ferrettiyachts/configurator.css';
import '../../css/ferrettiyachts/main.css';

import LocalizationsInfynito90 from '../Shared/Localization/Infynito90.json';
import LocalizationsInfynito80 from '../Shared/Localization/Infynito80.json';
import LocalizationContext from "../LocalizationContext";

import FeedbackAlert from "../Shared/FeedbackAlert";

import Intro from "../Configuration/Intro";
import IntroInLanding from "../Configuration/IntroInLanding";
import Configuration from "../Configuration/Configuration";
import Summary from "../Configuration/Summary";
import Finish from "../Configuration/Finish";

export const ConfigFerrettiInfynito = (props) => {
    const localizationCtx = useContext(LocalizationContext);
    const [indexStep, setIndexStep] = useState(props.indexStep);
    const [headerMessage, setHeaderMessage] = useState("");
    const [urlPage, setUrlPage] = useState("");
    const [urlLogo, setUrlLogo] = useState("");

    const updateConfigurationStep = (idxStep) => {
        setIndexStep(idxStep);

        if (idxStep === 1) {
            setHeaderMessage(localizationCtx.localizationData.configureTitle);
        }

        if (idxStep === 2) {
            setHeaderMessage(localizationCtx.localizationData.recapTitle);
        }

        if (idxStep === 3) {
            setHeaderMessage("");
        }
    }

    const [feedback, setFeedback] = useState({
        severity: "success",
        text: "Success",
        open: false,
    });

    const feedbackCallback = (severity, text, open) => {
        setFeedback({ severity: severity, text: text, open: open });
    };

    const alertClosed = () => {
        setFeedback({ ...feedback, open: false });
    };


    useEffect(() => {

        let myLocalization;

        if (props.modelCode === "Infynito90") {
            myLocalization = LocalizationsInfynito90.filter(function (local) {
                return local.cultureCode === props.cultureCode;
            });

            setUrlPage("/ConfiguratorFerrettiInfynito90");
            setUrlLogo("/images/logo-infynito90-white.png");
        }

        if (props.modelCode === "Infynito80") {
            myLocalization = LocalizationsInfynito80.filter(function (local) {
                return local.cultureCode === props.cultureCode;
            });

            setUrlPage("/ConfiguratorFerrettiInfynito80");
            setUrlLogo("/images/logo-infynito80-white.svg");
        }

        if (myLocalization.length === 1) {
            localizationCtx.updateLocalizationData(myLocalization[0]);
        }

        if (props.indexStep === 1) {
            setHeaderMessage(localizationCtx.localizationData.configureTitle);
        }

    }, []);

    // Google Analytics
    const location = "https://configurator.ferrettigroup.com/" + props.cultureCode + urlPage;
    const title = "Ferretti Group | Interactive Configurator - " + localizationCtx.localizationData.brandName + " " + localizationCtx.localizationData.modelName;

    if (urlPage !== '') {
        window.dataLayer.push({
            event: 'pageview',
            page: {
                url: location,
                title: title
            }
        });
    }



    return (
        <>

            {indexStep === -1 && <IntroInLanding modelCode={props.modelCode} cultureCode={props.cultureCode} updateStepCallBack={updateConfigurationStep} feedbackCallback={feedbackCallback} />
            }

            {indexStep !== -1 &&
                <div className="main-view-port">
                    <div className="container-fluid header-fy">
                        <div className="container-fluid">
                            <div className="row py-5 align-items-center">
                                <div className="col-lg-12 text-center">
                                    <img src={urlLogo} className="header-logo" />
                                    <p className="text-center h1 text-uppercase text-white text-header">{localizationCtx.localizationData.mainTitle}</p>
                                    {headerMessage !== "" && <p className="text-center h3 text-uppercase text-white text-header">{headerMessage}</p>}
                                </div>
                            </div>
                        </div>
                    </div>
                        <>
                            {indexStep === 0 &&
                                <Intro modelCode={props.modelCode} cultureCode={props.cultureCode} updateStepCallBack={updateConfigurationStep} feedbackCallback={feedbackCallback} />
                            }
                            {indexStep === 1 &&
                                <Configuration updateStepCallBack={updateConfigurationStep} feedbackCallback={feedbackCallback} returnUrl={props.returnUrl} />
                            }
                            {indexStep === 2 &&
                                <Summary updateStepCallBack={updateConfigurationStep} feedbackCallback={feedbackCallback} />
                            }
                            {indexStep === 3 &&
                                <Finish modelCode={props.modelCode} cultureCode={props.cultureCode} updateStepCallBack={updateConfigurationStep} feedbackCallback={feedbackCallback} />
                            }
                        </>
                </div>
            }
            <FeedbackAlert
                severity={feedback.severity}
                text={feedback.text}
                open={feedback.open}
                closedCallback={alertClosed}
                actionCallback={updateConfigurationStep}
            />
        </>
    );
};

export default ConfigFerrettiInfynito;
